import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';

import AngleDown from '@gef-ui/components/atoms/SvgIcon/Icons/AngleDown';
import AngleUp from '@gef-ui/components/atoms/SvgIcon/Icons/AngleUp';

import { useCollapsible } from 'features/common/Subheader/hooks';

const CollapsibleCard = ({ header, children, className, id, initiallyOpen }) => {
	const { visible, handleToggle } = useCollapsible({ id, initiallyOpen });

	const togglingArrow = (
		<Stack key="Card-toggle-arrow" text sx={{ width: '50px', justifyContent: 'center', alignItems: 'center' }}>
			<Box sx={{ color: 'primary.main', cursor: 'pointer' }}>
				{visible ? <AngleUp size="small" /> : <AngleDown size="small" />}
			</Box>
		</Stack>
	);

	return (
		<Stack
			className={className ? className : ''}
			sx={{
				mb: 2.5,
			}}
		>
			<Stack className="CardHeader" direction="row" onClick={handleToggle}>
				{header}
				{children && togglingArrow}
			</Stack>
			<Collapse in={visible}>
				<Box sx={{ background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0))' }}>
					{children}
				</Box>
			</Collapse>
		</Stack>
	);
};

CollapsibleCard.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	header: PropTypes.any,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	initiallyOpen: PropTypes.bool,
};

export default CollapsibleCard;
